// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"8b7f96fb","453":"f92166de","477":"78900bd1","553":"e9012e1c","554":"c5733cb5","706":"b4336dd9","715":"7f1afebc","801":"bdf88544","882":"1acd1233","926":"65b0c100"}[chunkId] + ".chunk.js";
};